import { IconBase, IconComponent } from './BaseIcon';

export const Shirt: IconComponent<{ design?: boolean }> = ({ design, ...props }) => (
  <IconBase {...props}>
    <path d="m.7 11.1 6 5.9L8 15.6v10.5c0 1.6 1.3 2.9 2.9 2.9h10.2a3 3 0 0 0 3-2.9V15.5l1.4 1.5 6-5.9-8.1-8h-5.3v1a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-1H8.7zm2.8 0 6-6h2.6c.5 1.7 2.1 3 3.9 3a4 4 0 0 0 3.9-3h2.7l6 6-3.1 3-3.4-3.5v15.5c0 .5-.4.9-1 .9H10.9a.9.9 0 0 1-.9-.9V10.6l-3.4 3.5z" />
    {design && (
      <path d="m9.9 16.6 2-2 2.5 1.7 4.1-4.1 3.7 3.7v2.8L18.5 15l-3.9 4-2.5-1.8-2.2 2.2zm3.1-4.9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 1 1-3 0z" />
    )}
  </IconBase>
);
